module.exports = __webpack_public_path__ + "static/media/retail.24c5dfcf.jpg";